module.exports = function () {
    const navigations = document.querySelectorAll(".navigation-accordion");
    if ( !navigations.length ) return;

    for (const navigation of navigations) {
        const navigationWrapper = navigation.querySelector(".navigation-wrapper");
        const navigationContent = navigation.querySelector(".navigation-content");
        const button = navigation.querySelector(".navigation-button");

        const navigationHero = navigation.closest(".hero-navigation");
        const navigationHeroStandard = navigationHero.querySelector(".hero-navigation__standard");

        if ( !( navigationContent && navigationWrapper && navigationHero && navigationHeroStandard && button ) ) return;

        init();

        navigationHeroStandard.addEventListener("click", (e) => {
            const link = e.target.closest("a");
            if (link && link.getAttribute("href")?.startsWith("#")) {
                e.preventDefault();
                const href = link.getAttribute("href");
                const target = document.querySelector(href);
                
                if (target) {
                    // Get the top position of the element relative to the document
                    const rectTop = target.getBoundingClientRect().top + window.scrollY;

                    // If mobile, scroll to 100px above
                    const offset = window.innerWidth <= 1023 ? 100 : 0;

                    // Scroll to adjusted position
                    window.scrollTo({
                        top: rectTop - offset,
                        behavior: "smooth"
                    });

                    history.pushState(null, '', href); // update the URL
                }
            }
        });

        function init() {
            accordionControl();
            switchNavigation();
            fixedNavigation();
        }

        function accordionControl() {
            if ( !button ) return;

            button?.addEventListener("click", () => {
                if ( navigation.classList.contains("open") ) {
                    close();
                }
                else {
                    open();
                }
            })

            // navigationContent.addEventListener("click", (e) => {
            //     if ( e.target.tagName === "A" || e.target.tagName === "BUTTON" ) close();
            // })
            // navigationContent.addEventListener("click", (e) => {
            //     const link = e.target.closest("a");
            //     if (link && link.getAttribute("href")?.startsWith("#")) {
            //         e.preventDefault(); // prevent default jump
            //         const href = link.getAttribute("href");
            //         const target = document.querySelector(href);
            //
            //         if (target) {
            //             history.pushState(null, '', href); // update the URL
            //             target.scrollIntoView({ behavior: 'smooth' }); // smooth scroll
            //         }
            //
            //         close();
            //     }
            // });
            navigationContent.addEventListener("click", (e) => {
                const link = e.target.closest("a");
                if (link && link.getAttribute("href")?.startsWith("#")) {
                    e.preventDefault(); // prevent default jump
                    const href = link.getAttribute("href");
                    const target = document.querySelector(href);

                    if (target) {
                        // Get the top position of the element relative to the document
                        const rectTop = target.getBoundingClientRect().top + window.scrollY;

                        // If mobile, scroll to 100px above
                        const offset = window.innerWidth <= 1023 ? 100 : 0;

                        // Scroll to adjusted position
                        window.scrollTo({
                            top: rectTop - offset,
                            behavior: "smooth"
                        });

                        history.pushState(null, '', href); // update the URL
                    }

                    close();
                }
            });

        }

        function open() {
            navigation.classList.add("open");
            setTimeout(() => document.addEventListener("click", closeOutSide));
        }

        function close() {
            navigation.classList.remove("open");
            document.removeEventListener("click", closeOutSide);
        }

        function closeOutSide(e) {
            if ( !navigationContent.contains(e.target) ) close();
        }

        // navigation switch between accordion and list
        function switchNavigation() {
            function update() {
                close();
            }

            update();
            window.addEventListener("resize", update);
        }

        function fixedNavigation() {
            const navClasses = ["hero-navigation--fixed"];

            window.addEventListener("scroll", () => {
                navigationHero.classList.add("animate");

                if ( navigationHero.closest("section")?.getBoundingClientRect().bottom <= 0 ) {
                    navigationHero.classList.add(...navClasses);

                    if ( navigation.classList.contains("open") ) close();

                    if ( document.querySelector(".header:not(.scrolledDown)") ) {
                        navigationHero.classList.add("down");
                    }
                    else {
                        navigationHero.classList.remove("down");
                    }
                }
                else {
                    navigationHero.classList.remove(...navClasses);
                    navigationHero.classList.remove("down");
                }
            });
        }
    }
}